/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

import * as Blockly from "blockly/core";
import "blockly/python";
import { AreaService } from "@/services/area.service";
import { getAllowedStatements } from "../block_compatibility_checks";
import { areaChange } from '../helper_functions';

const compareOptions = [
    ["None", "none"],
    ["Annual Forest Loss", "hansen_forest_loss"],
    ["Estimated Forest Cover", "hansen_tree_cover"],
    ["ESA 10m Land Cover", "esa_landcover"],
    ["Copernicus Land Cover", "copernicus_landcover"]
];

Blockly.Blocks['input_biomass'] = {
    init: function () {
        var area_dropdown = AreaService.getAreas();
        this.appendDummyInput("heading")
            .appendField(new Blockly.FieldLabelSerializable("Biomass"), "heading_text")
        this.appendDummyInput("data_input")
            .appendField(new Blockly.FieldLabelSerializable("Biomass data: "), "dropdown_text")
            .appendField(new Blockly.FieldDropdown([["Biomass (2010)", "biomass_nasa_2010"]]), "dropdown")
            .setAlign(Blockly.ALIGN_LEFT)
        this.appendDummyInput("area_input")
            .appendField(new Blockly.FieldLabelSerializable("Area: "), "area_text")
            .appendField(new Blockly.FieldDropdown(area_dropdown), "area")
            .setAlign(Blockly.ALIGN_LEFT)
        this.appendDummyInput("second_data_input")
            .appendField(new Blockly.FieldLabelSerializable("Classifying by: "), "secondary_data_text")
            .appendField(new Blockly.FieldDropdown(compareOptions, this.validateAdditionalData), "secondary_data")
            .setAlign(Blockly.ALIGN_LEFT);

        this.appendStatementInput("do").setCheck(
            getAllowedStatements("biomass")
        );
    
        this.setInputsInline(false);
        this.setStyle("biomass");

        this.areaSubscription = AreaService.areaChange$.subscribe( () => {
            let result = areaChange(this, "area_input", "area");
            if(!result) {
                this.areaSubscription.unsubscribe();
            }
        });
    },

    /**
     * On user selection change of additional data, check if the value is equal to some parameter in which
     * we want to add extra field values to the block.
     * @param {String} newValue - the users selected value
     * @returns {String} validatedValue - returns validated dropdown value
     */
    validateAdditionalData: function(newValue) {
        let treeParamList = ['hansen_forest_loss', 'hansen_tree_cover']
        let sourceBlock = this.getSourceBlock()
        sourceBlock.showCanopyCover = treeParamList.includes(newValue)
        sourceBlock.updateCanopyCoverField();
        return newValue;
    },

    /**
     * Copied from input_hansen_forest_change.js - TODO: we should put this in a separate file to resuse
     * called whenever the user selects a dropdown option, checks boolean showCanopyCover to see if the
     * canopyCoverControl fields need to be added/removed from the block
     */
     updateCanopyCoverField: function() {
        if(this.showCanopyCover && !this.getInput("canopyCoverControls")) {
            this.appendDummyInput("canopyCoverControls")
                .setAlign(Blockly.ALIGN_LEFT);

            // move new dummy input to before the C block section
            this.moveInputBefore("canopyCoverControls", "do")

            // create number field
            let canopyCoverControls = this.getInput("canopyCoverControls");
            canopyCoverControls
                .appendField("Where canopy cover is at least")
                .appendField(
                    new Blockly.FieldNumber(
                        10, // default
                        0, // min
                        100, // max
                        1 // precision
                    ), "minimumCanopyCover")
                .appendField("%")

        } else if (!this.showCanopyCover && this.getInput("canopyCoverControls")){
            // remove input
            this.removeInput("canopyCoverControls");
        }
    },
};